import React from 'react';
import { ABNTSection } from '@/data/manuals/fleetone-abnt-content';
import { cn } from '@/lib/utils';

interface ManualABNTTOCProps {
  sections: ABNTSection[];
  activeSection: string;
  onSectionClick: (sectionNumber: string) => void;
  showPageNumbers?: boolean;
}

export const ManualABNTTOC: React.FC<ManualABNTTOCProps> = ({
  sections,
  activeSection,
  onSectionClick,
  showPageNumbers = false
}) => {
  const renderTOCItem = (section: ABNTSection, depth: number = 0) => {
    const isActive = activeSection === section.number;
    const indent = depth * 16;

    return (
      <li key={section.number}>
        <button
          onClick={() => onSectionClick(section.number)}
          className={cn(
            'w-full text-left py-1 px-2 rounded-md transition-colors hover:bg-muted text-sm',
            isActive && 'bg-muted text-primary font-semibold'
          )}
        >
          {section.number} {section.title}
        </button>

        {section.subsections && section.subsections.length > 0 && (
          <ol style={{ paddingLeft: `${indent + 18}px` }}>
            {section.subsections.map((subsection) => 
              renderTOCItem(subsection, depth + 1)
            )}
          </ol>
        )}
      </li>
    );
  };

  return (
    <nav className="toc" aria-label="Sumário">
      <h3 className="text-xs font-semibold text-muted-foreground mb-2 uppercase tracking-wider">
        Sumário
      </h3>
      <ol className="space-y-1">
        {sections.map((section) => renderTOCItem(section))}
      </ol>
    </nav>
  );
};
